import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntypedFormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RequestService } from '../services/request.service';

@Component({
  selector: 'app-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {
  form: any;

  constructor(public fb: UntypedFormBuilder, private request: RequestService, private router: Router) {
    this.form = this.fb.group({
      password: ['', Validators.required],
      password_confirm: ['', Validators.required]
    });
  }

  ngOnInit() {

  }
  submit() {
    const r = confirm('パスワードを変更しますか？');
    if (r === true) {
      if (this.form.value.password !== this.form.value.password_confirm) {
        alert('パスワードが一致してません。');
        return;
      }
      if (!this.checkPassWord(this.form.value.password)) {
        alert('英文字と数字を含む、８桁のパスワードを入力してください。');
        return;
      }
      console.log(this.form.value);
      this.form.value.admin = true;
      this.request.post('api/auth/changePassword', this.form.value).then(res => {
        alert('パスワードが変更されました、新しいパスワードでログインしてください。');
        this.router.navigate(['/login']);
      });
    }
  }

  checkPassWord(password: any) {
    const str = password;
    if (str == null || str.length < 8) {
        return false;
    }
    const reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
    if (reg.test(str)) {
      return true;
    }
    return false;
  }
}
